// @flow

import React from 'react';
import cx from 'classnames';

type Props = {
  activeTab: number,
  label: string,
  onClick: Function,
  position: number,
};

const TabItem = (props: Props) => {
  const { activeTab, label, onClick, position } = props;
  const isActive = activeTab === position;

  const handleClick = () => {
    onClick(position);
  };

  return (
    <button className={cx('tab-list-item', { 'tab-list-active': isActive })} onClick={handleClick}>
      {label}
      <span className="arrow-up" />
    </button>
  );
};

TabItem.defaultProps = {
  activeTab: '',
  label: '',
  onClick: () => {},
};

export default TabItem;
